import { PortfolioTemplateFeeCalculatorDataDTO } from "@models/managed-accounts/entities/step/setup";
import { PortfolioFeeCalculatorDataDTO } from "@models/platform-analysis/entities/steps/fee";
import { isNil } from "lodash";
import * as Yup from "yup";

export const portfolioTemplateValidators = Yup.object().shape({
  name: Yup.string().nullable(true).required("Portfolio template must has a name"),
});

export const mapPortfolioFeeCalculatorsWithTemplates = (
  portfolioFeeCalculatorsData: PortfolioFeeCalculatorDataDTO[],
): PortfolioTemplateFeeCalculatorDataDTO[] => {
  return portfolioFeeCalculatorsData.map((item) => ({
    variableName: item.variableName,
    value: !isNil(item.value) ? Number(item.value) : null,
    weight: !isNil(item.weight) ? Number(item.weight) : null,
  }));
};